export default __webpack_public_path__ + "53c30eb6011cfe6be4651510dd5a574d.svg";